import { render, staticRenderFns } from "./ViewInvoice.vue?vue&type=template&id=6c8d511a&scoped=true&"
import script from "./ViewInvoice.vue?vue&type=script&lang=js&"
export * from "./ViewInvoice.vue?vue&type=script&lang=js&"
import style0 from "./ViewInvoice.vue?vue&type=style&index=0&id=6c8d511a&prod&scoped=true&lang=css&"
import style1 from "./ViewInvoice.vue?vue&type=style&index=1&id=6c8d511a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8d511a",
  null
  
)

export default component.exports